<template>
  <div class="tariff-tabs-row" id="basic">
    <div class="tariff-tab">
      Basic Training Zone
    </div>
    <button type="button" class="tariff-stebby-button" @click="openModal">
      {{ $t('packages.stebby.button') }}
    </button>
  </div>
  <ModalWindow
    v-if="showModal"
    :title="$t('packages.stebby.button')"
    subtitle=""
    @closeModal="closeModal"
  >
    <p class="stebby-modal-text" v-html="$t('packages.stebby.modalText')"></p>
    <button
      type="button"
      class="stebby-modal-ok"
      @click="closeModal"
    >
      {{ $t('homeNew.startOffers.modalOk') }}
    </button>
  </ModalWindow>
</template>

<script>
import ModalWindow from '@/components/ModalWindow.vue';

export default {
  name: "TariffTabs",
  components: {
    ModalWindow,
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
      document.body.classList.add('menu-open');
    },
    closeModal() {
      this.showModal = false;
      document.body.classList.remove('menu-open');
    },
  },
}
</script>

<style scoped>
.tariff-tabs-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  gap: 12px;
  margin: 40px 0 20px;
}

@media screen and (min-width: 1024px) {
  .tariff-tabs-row {
    margin: 80px 0 40px;
  }
}

.tariff-tab,
.tariff-stebby-button {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 20px;
  line-height: 1.2;
  padding: 6px 32px;
  border: 2px solid #000000;
  border-radius: 40px;
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  .tariff-tab,
  .tariff-stebby-button {
    font-size: 24px;
  }
}

.tariff-tab {
  background-color: #000000;
  color: white;
}

.tariff-stebby-button {
  font-family: inherit;
  background-color: #ffffff;
  color: #000000;
}

.tariff-stebby-button:hover {
  background-color: #000000;
  color: #ffffff;
  transition: all 0.3s;
}

.stebby-modal-text {
  margin: 24px 0 0;
  white-space: pre-line;
  line-height: 1.5;
  font-size: 16px;
  font-weight: 400;
  color: #000;
}

.stebby-modal-text :deep(a) {
  color: #000;
  text-decoration: underline;
  word-break: break-all;
}

:deep(.heading) {
  text-transform: uppercase;
  margin-bottom: 0;
}

:deep(.modal-buttons) {
  justify-content: flex-end;
  margin-bottom: 0;
  padding-bottom: 0;
}

@media screen and (min-width: 768px) {
  .stebby-modal-text {
    font-size: 18px;
  }
}

.stebby-modal-ok {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 152px;
  height: 44px;
  margin: 32px auto 0;
  border-radius: 22px;
  font-size: 20px;
  font-weight: 400;
  line-height: 1;
  color: #fff;
  background: #000;
  border: none;
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  .stebby-modal-ok {
    width: 180px;
    font-size: 24px;
  }
}
</style>
